import { Link } from "react-router-dom";
import { useApi } from "../../lib/useApi";
import { PageHeader, Card, Spinner, EmptyState } from "../../components/ui";
import { StatusBadge } from "../../components/StatusBadge";
import { date, money } from "../../lib/format";
import type { CaseRow, Page } from "../../lib/types";

export function PortalCases() {
  const { data, loading } = useApi<Page<CaseRow>>("/api/portal/cases?limit=100");
  if (loading) return <Spinner />;
  const rows = data?.data ?? [];

  return (
    <>
      <PageHeader title="Mis expedientes" />
      {rows.length === 0 ? (
        <EmptyState>No tienes expedientes todavía.</EmptyState>
      ) : (
        <Card className="overflow-x-auto">
          <table className="w-full whitespace-nowrap text-sm">
            <thead className="border-b border-line text-left text-xs uppercase tracking-wide text-muted">
              <tr>
                <th className="px-5 py-3 font-medium">Referencia</th>
                <th className="px-5 py-3 font-medium">Estado</th>
                <th className="px-5 py-3 font-medium">Importe</th>
                <th className="px-5 py-3 font-medium">Creado</th>
              </tr>
            </thead>
            <tbody className="divide-y divide-line">
              {rows.map((c) => (
                <tr key={c.id} className="hover:bg-canvas">
                  <td className="px-5 py-3">
                    <Link to={`/cases/${c.id}`} className="font-mono font-medium text-accent-600 hover:underline">{c.publicRef}</Link>
                  </td>
                  <td className="px-5 py-3"><StatusBadge status={c.status} /></td>
                  <td className="px-5 py-3 tnum">{money(c.priceMinor, c.currency ?? "EUR")}</td>
                  <td className="px-5 py-3 text-muted">{date(c.createdAt)}</td>
                </tr>
              ))}
            </tbody>
          </table>
        </Card>
      )}
    </>
  );
}
